import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PanelizationPage } from '@/areas/pcb/Pcb/PanelizationPage/PanelizationPage';
import { PcbTabRoute } from '@/areas/pcb/Pcb/PcbLayout/PcbTabRoute';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ currentParentAssemblyId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbTabRoute tab={PanelizationPage} />;
}
